import Link from "next/link";

const hero_12 = () => {
  return (
    <section className="relative">
      <picture className="pointer-events-none absolute inset-0 -z-10">
        <img
          src="/images/gradient_dark.jpg"
          alt="gradient dark"
          className="h-full w-full"
        />
      </picture>
      <div className="container pt-[100px]">
        <div className="flex flex-col lg:grid lg:grid-cols-12 items-center">
          <div className="py-10 lg:col-span-6 order-last lg:order-first">
            <div className="items-center gap-4">
              <div className="flex h-full flex-col items-center justify-center lg:items-start py-10 lg:py-20">
                <p className="items-center mb-5 inline-block bg-gradient-to-r text-accent-light bg-clip-text text-lg">
                  Decentralized Application
                </p>
                <h1 className="mb-8 text-center font-display text-5xl text-white md:text-left lg:text-6xl">
                  Alchemis Token Tool
                </h1>
                <p className="mb-8 max-w-xl lg:max-w-md font-normal text-center text-lg dark:text-jacarta-200 lg:text-left">
                  Alchemis TokenTool platform for batch operations and managing digital assets effortlessly. Harness the power of blockchain technology with our user-friendly interface designed for beginners.
                </p>
                <div className="flex space-x-4 items-center">
                  <Link href="/collection/explore_collection" legacyBehavior>
                    <a className="rounded-full bg-primary py-3 px-8 text-center font-semibold text-white transition-all hover:bg-accent-dark">
                      Get Started
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="relative max-w-[500px] lg:max-w-[100%] lg:w-full col-span-8 lg:col-span-6 order-first lg:order-last">
            <div className="flex items-center space-x-7">
              <img
                src="/images/token-tool/tokentool-header.png"
                alt="hero"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default hero_12;
